import * as actions from '@app/actions/index';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import SettingsComponent from './settings.component';

function mapStateToProps(authState: any): any {
	return {
		intl: null,
	};
}

function mapDispatchToProps(dispatch: Dispatch<actions.AuthActions>): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsComponent);



// WEBPACK FOOTER //
// ./src/components/admin/setting/settings.ts